export default __webpack_public_path__ + "static/media/misc-books4-1024w.f1767e4d.webp";